module.exports = "<app-top-nav></app-top-nav>\n<app-minesweeper></app-minesweeper>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 156
// module chunks = 1